import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';

interface IAuthState {
    token: string;
}

const initialState: IAuthState = {
    token: ''
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setToken: (state, action:PayloadAction<string>) => {
            state.token = action.payload;
        }
    },
});

const { 
    setToken, 
} = authSlice.actions;

export const setAuthToken = 
  (token: string): AppThunk =>
  async (dispatch) => {
   dispatch(setToken(token));
};

export const selectAuth = (state: RootState) =>
  state.authState;

export default authSlice.reducer;